<script setup>
import AddUserIcon from '@/icons/AddUserIcon'
import MoneyIcon from '@/icons/MoneyIcon'
import OverdueIcon from '@/icons/OverdueIcon'
import ExpiredIcon from '@/icons/ExpiredIcon'
import DashboardStatsAdminCard from '@/Components/Dashboard/DashboardStatsAdminCard'
import NumActiveMembers from '@/Components/Dashboard/Widgets/NumActiveMembers'
import OverdueInvoices from '@/Components/Dashboard/Widgets/OverdueInvoices'
import InvoicesNext30Days from '@/Components/Dashboard/Widgets/InvoicesNext30Days'
import FailedJobs from '@/Components/Dashboard/Widgets/FailedJobs'
import NextEvent from '@/Components/Dashboard/Widgets/NextEvent'
import DashboardStatsUserCard from '@/Components/Dashboard/DashboardStatsUserCard'
import moment from 'moment';

import { ref, computed, onMounted } from 'vue'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

import { useErrorsStore } from '@/Stores/errors'
const errors = useErrorsStore()

const props = defineProps({
	adminStats: {
		type: Object,
		default: null,
	}
})

const invoices = ref(null)
function fetchInvoices() {
    return axios.get('/api/invoices')
    .then(response => {
        invoices.value = response.data
    })
    .catch(error => {
		invoices.value = []
    })
}

onMounted(() => {
	fetchInvoices()
})
</script>

<template>
	<div v-if="auth.isAdmin" class="grid gap-4 md:gap-2 lg:gap-4 grid-cols-1 md:grid-cols-3 w-[100%]">
	
		<NumActiveMembers 
			:active="adminStats.activeMembers"
			:inactive="adminStats.inactiveMembers"
			:total="adminStats.totalMembers"
		/>

		<OverdueInvoices
			:invoices="invoices"
		/>

		<InvoicesNext30Days
			:invoices="invoices"
		/>

		<FailedJobs
			:jobs="adminStats.failedJobs"
		/>

		<NextEvent
			:event-data="adminStats.nextEventData"
			:num-active-members="adminStats.activeMembers"
		/>
	</div>
</template>

